import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from 'app/dashboard/dashboard.component';
import { MessagesStatus, MessagesTitles } from 'app/models/messages';
import { EmpresasService } from 'app/services/empresas/empresas.service';
import { RiesgoService } from 'app/services/riesgo/riesgo.service';
import { environment } from 'environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-aval-juridico',
  templateUrl: './aval-juridico.component.html',
  styleUrls: ['./aval-juridico.component.scss'],
  providers: [MessagesTitles, MessagesStatus, DatePipe, {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE]
  },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class AvalJuridicoComponent {
  Id_Carnet = environment.ID_CARNET;
  Id_Ruc = environment.ID_RUC;
  @Output() cerrarAgregarAvalJ: EventEmitter<boolean> = new EventEmitter();
  @Output() refresh: EventEmitter<boolean> = new EventEmitter();

  igvExoneradoElement: string;
  tipoDocumentoElement: string;
  form: FormGroup;
  loading: boolean = false;
  datos = {
    Num_Doc_Identificacion: "",
  }
  user: any;
  avaljuridico;
  msgError: any;

  constructor(private riesgoService: RiesgoService,
    private empresasService: EmpresasService,
    private msgStatus: MessagesStatus,
    private msgTitulos: MessagesTitles,
    private datePipe: DatePipe,) {
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));

    this.form = new FormGroup({
      // proveedorNombre_Comercial
      TipoEmpresa: new FormControl('J', [Validators.required]),
      Razon_Social: new FormControl({ value: "", disabled: false }, [Validators.required]),
      Num_Doc_Identificacion: new FormControl({ value: "", disabled: false }, [Validators.required, Validators.pattern("[0-9]{11}$")]),
      Nombre_Comercial: new FormControl('', [Validators.required]),
      Tipo_Doc_Identificacion: new FormControl("", [Validators.required]),
      Direccion_Fiscal: new FormControl({ value: "", disabled: false }, [Validators.required]),
      Departamento: new FormControl({ value: "", disabled: false }, [Validators.required]),
      Provincia: new FormControl({ value: "", disabled: false }, [Validators.required]),
      Distrito: new FormControl({ value: "", disabled: false }, [Validators.required]),
      Pais: new FormControl('', [Validators.required]),
      UBIGEO: new FormControl('',),
      Scoring_Puntaje: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Scoring_Fecha_Consulta: new FormControl({ value: this.datePipe.transform(Date(), "yyyy-MM-dd"), disabled: true }, [Validators.required]),
      Estado: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Condicion: new FormControl('',),
      Alta_Fecha: new FormControl('',),
      Fecha_Adjuntos: new FormControl(this.datePipe.transform(Date(), "yyyy-MM-dd"), []),
      Alta_Canal: new FormControl('', []),
      Alta_Usuario: new FormControl('', []),
      Modificaion_Fecha: new FormControl('', []),
      Modificaion_Canal: new FormControl('W', []),
      Modificaion_Usuario: new FormControl('', []),
      Usuario: new FormControl('', [])
    });

  }

  CerrarPopUp() {
    this.cerrarAgregarAvalJ.emit();
    this.refresh.emit();
  }

  tipoDocumento(event) {
    this.form.controls['Tipo_Doc_Identificacion'].setValue(event);
  }

  validarNumDocumento() {

    if (this.form.controls['Num_Doc_Identificacion'].invalid) {
      Swal.fire({
        title: '¡Advertencia!',
        text: 'Número de identificación no válido.',
        type: 'warning',
        allowOutsideClick: true,
        heightAuto: false
      });
    }
    else {
      this.loading = true;
      this.riesgoService.riesgoRUC(this.datos).subscribe(res => {
        if (res['message']) {
          this.loading = false;
          Swal.fire({
            title: '¡Advertencia!',
            text: 'Número de identificación no válido.',
            type: 'warning',
            allowOutsideClick: true,
            heightAuto: false
          });
          this.crearFormulario();

        } else {

          this.avaljuridico = res;
          this.cargarCampos();
          this.loading = false;
        }

      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Data no encontrado. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      });
    }
  }

  crearFormulario() {

    this.form = new FormGroup({
      TipoEmpresa: new FormControl('J', [Validators.required]),
      Razon_Social: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Num_Doc_Identificacion: new FormControl('', [Validators.required, Validators.pattern("[0-9]{11}$")]),
      Nombre_Comercial: new FormControl('', [Validators.required]),
      Tipo_Doc_Identificacion: new FormControl('', [Validators.required]),
      Direccion_Fiscal: new FormControl({ value: "", disabled: false }, [Validators.required]),
      Departamento: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Provincia: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Distrito: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Pais: new FormControl('Perú', [Validators.required]),
      UBIGEO: new FormControl('', []),
      Scoring_Puntaje: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Scoring_Fecha_Consulta: new FormControl({ value: this.datePipe.transform(Date(), "yyyy-MM-dd"), disabled: true }, [Validators.required]),
      Estado: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Condicion: new FormControl('',),
      Alta_Fecha: new FormControl('',),
      Fecha_Adjuntos: new FormControl(this.datePipe.transform(Date(), "yyyy-MM-dd"), []),
      Alta_Usuario: new FormControl(this.user.Usuario, []),
      Adjunto_Ficha_Ruc: new FormControl("", []),
      Adjunto_Copia_Literal: new FormControl("", []),
      Alta_Canal: new FormControl("W", []),
      Modificaion_Fecha: new FormControl('', []),
      Modificaion_Canal: new FormControl('', []),
      Modificaion_Usuario: new FormControl('', []),
      Usuario: new FormControl(this.user.Usuario, [])
    });
  }

  cargarCampos() {

    this.crearFormulario();
    this.form.controls['Scoring_Fecha_Consulta'].setValue(this.datePipe.transform(Date(), "yyyy-MM-dd"));

    this.form.controls['Num_Doc_Identificacion'].setValue(this.avaljuridico.Documento);
    this.form.controls['Razon_Social'].setValue(this.avaljuridico.RazonSocial);
    this.form.controls['Nombre_Comercial'].setValue(this.avaljuridico.RazonSocial);
    this.form.controls['Direccion_Fiscal'].setValue(this.avaljuridico.NomVia + " - " + this.avaljuridico.NumPredio);
    this.form.controls['Departamento'].setValue(this.avaljuridico.Departamento);
    this.form.controls['Provincia'].setValue(this.avaljuridico.Provincia);
    this.form.controls['Distrito'].setValue(this.avaljuridico.Distrito);
    this.form.controls['Scoring_Puntaje'].setValue(this.avaljuridico.ScoreBuro);
    this.form.controls['Tipo_Doc_Identificacion'].setValue(this.Id_Ruc);

    switch (this.avaljuridico.EstadoContribuyente) {
      case 'ACTIVO': this.form.controls['Estado'].setValue('A');

        break;
      case 'INHABILITADO-VENT.UNICA': this.form.controls['Estado'].setValue('X');

        break;

      default: this.form.controls['Estado'].setValue('B');
        break;
    }
  }

  guardarCambios() {
    if (this.form.invalid) {
      Swal.fire({
        title: 'Incomplete form!',
        text: 'Complete todos los campos requeridos del formulario.',
        type: 'info',
        allowOutsideClick: false,
        heightAuto: false
      });
      return;
    }
    Swal.fire({
      title: '¡Espere!',
      text: 'Estamos guardando la información',
      type: 'info',
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();
    this.empresasService.registrarEmpresa(this.form.getRawValue())
      .subscribe(res => {
        this.empresasService.obtenerAvalJuridico().subscribe(res1 => {
          sessionStorage.setItem('lstavlCbo', JSON.stringify(res1));
          Swal.fire({
            title: "¡Éxito!",
            text: 'Contact guardado correctamente.',
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(resp => {
            if (resp.value == true) {
              this.CerrarPopUp();
            }
          })
        });
      }, (err: HttpErrorResponse) => {
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: "A problem occurred!",
          text: "Contact not registered. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });

      });
  }

}
